import historicalArbitrageInquiry from './historical-arbitrage-inquiry.vue'
export default historicalArbitrageInquiry
